export default __webpack_public_path__ + "static/media/Hospital.3b00340b.svg";